import { useState, useEffect } from "react";
import { SchedulerStoreType } from "../state/scheduler.store";

export const useErrorDialog = (
  sessionData: SchedulerStoreType["sessionData"]
) => {
  const [openErrorDialogState, setErrorDialogState] = useState(false);

  const handleOpenErrorDialog = (state: boolean) => {
    setErrorDialogState(state);
  };

  useEffect(() => {
    if (sessionData?.validated === "validation_failed") {
      setErrorDialogState(true);
    }
  }, [sessionData?.validated]);

  return { openErrorDialogState, handleOpenErrorDialog };
};
